// utils/sanitizeGeneratedSql.js

/**
 * Removes unsafe epoch division when column is already DATE.
 * Converts:
 *   order_date / 1000
 * Into:
 *   CAST(order_date AS DATE)
 */

export const sanitizeGeneratedSql = async (sql, executeQuery) => {
  if (!sql || !sql.includes('/')) return sql;

  try {
    // Get all tables in DB
    const tables = await executeQuery(`SHOW TABLES;`);

    const applySchemaToSql = (currentSql, schema) =>
      schema.reduce((acc, col) => {
        if (col.column_type?.toUpperCase() !== 'DATE') {
          return acc;
        }

        const colName = col.column_name;
        const regex = new RegExp(`\\b${colName}\\s*/\\s*1000\\b`, 'gi');

        if (!regex.test(acc)) {
          return acc;
        }

        console.log(`🛠 Fixing epoch division on ${colName}`);
        return acc.replace(regex, `CAST(${colName} AS DATE)`);
      }, currentSql);

    const steps = tables.map((tbl) => {
      const tableName = Object.values(tbl)[0];
      return (currentSql) =>
        executeQuery(`DESCRIBE ${tableName};`).then((schema) =>
          applySchemaToSql(currentSql, schema)
        );
    });

    const updatedSql = await steps.reduce(
      (promise, step) => promise.then(step),
      Promise.resolve(sql)
    );

    return updatedSql;
  } catch (err) {
    console.warn("⚠️ SQL sanitization failed, using original SQL");
    return sql;
  }
};